import { CardListPage } from "components/Category/Category";
import React, { SetStateAction } from "react";

import cardIcon from "assets/Icon_Toggle_Card_01.png";
import activeCardIcon from "assets/Icon_Toggle_Card_02.png";
import listIcon from "assets/Icon_Toggle_List_01.png";
import activeListIcon from "assets/Icon_Toggle_List_02.png";

type CardListPageToggleProps = {
  page: CardListPage;
  setCardList: React.Dispatch<SetStateAction<CardListPage>>;
  onOptionSelected: () => void;
  cardViewEnabled: boolean;
};

const CardListPageToggle: React.FC<CardListPageToggleProps> = ({
  page,
  setCardList,
  onOptionSelected,
  cardViewEnabled,
}) => {
  const cardActive = page === CardListPage.Card;
  const listActive = page === CardListPage.List;

  const handleClick = (isCard: boolean) => {
    onOptionSelected();

    if (isCard) setCardList(CardListPage.Card);
    else setCardList(CardListPage.List);
  };

  return (
    <div className="CardListToggleContainer">
      <div
        className={`Option Card ${cardActive ? "Active" : ""} ${
          !cardViewEnabled ? "Disabled" : ""
        }`}
        onClick={() => {
          if (cardViewEnabled) {
            handleClick(true);
          }
        }}
      >
        <div className="IconContainer">
          <img
            src={cardActive ? activeCardIcon : cardIcon}
            alt="card page"
            className="Icon"
          />
        </div>

        <div className="TextContainer">
          <div className="Text">Card view</div>
        </div>
      </div>
      <div
        className={`Option List ${listActive ? "Active" : ""}`}
        onClick={() => handleClick(false)}
      >
        <div className="IconContainer">
          <img
            src={listActive ? activeListIcon : listIcon}
            alt="list page"
            className="Icon"
          />
        </div>

        <div className="TextContainer">
          <div className="Text">List view</div>
        </div>
      </div>
    </div>
  );
};

export default CardListPageToggle;
